<template>
  <div class="company-seal" :style="{ width: size + 'px', height: size + 'px' }">
    <img
      class="seal-img"
      :src="sealSrc"
      alt="安享花金融服务有限公司合同专用章"
      draggable="false"
    />
  </div>
</template>

<script>
export default {
  name: 'CompanySeal',
  props: {
    size: {
      type: Number,
      default: 120
    }
  },
  data() {
    return {
      sealSrc: require('../assets/img/seal-axh-official.png')
    }
  }
}
</script>

<style scoped>
.company-seal {
  display: inline-block;
  line-height: 0;
  pointer-events: none;
  user-select: none;
}
.seal-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  /* 白色底变透明，红色叠印在文字上，底下黑字可见 */
  mix-blend-mode: multiply;
  opacity: 0.92;
}
</style>
